// Guaranty Multi-Signer — a loan's guaranty roster read + the staff "Send
// guaranties" mutation. The read registers under the co-located key factory;
// send invalidates the loan's roster (statuses flip Pending → Sent) and loan
// HEALTH (guaranties are a loan-state fact the Overview attention feed / tab
// badges may surface). Toasts + ApiError rendering happen in the caller.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { guarantiesApi } from "@/api/portfolioAdmin/guarantiesApi";
import { invalidateLoanHealth } from "@/hooks/portfolioAdmin/invalidation";
import { guarantyKeys } from "@/hooks/portfolioAdmin/guarantyKeys";

export function useGuaranties(loanId: string | undefined) {
  return useQuery({
    queryKey: guarantyKeys.forLoan(loanId ?? ""),
    queryFn: () => guarantiesApi.forLoan(loanId!),
    enabled: !!loanId,
  });
}

export function useSendGuaranties(loanId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => guarantiesApi.send(loanId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: guarantyKeys.forLoan(loanId) });
      void invalidateLoanHealth(qc, loanId);
    },
  });
}
